import React, {Component, useEffect, useState} from "react";
import {
  IonButton, IonButtons, IonCheckbox, IonCol,
  IonContent, IonFooter, IonGrid,
  IonHeader, IonIcon, IonInput,
  IonItem,
  IonLabel, IonList, IonModal, IonRow, IonSelect, IonSelectOption,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "../common/Common.css"
import {loadResource, updateResource} from "../common/ApiUtils";
import {create, trash} from "ionicons/icons";
import {gliderInfo} from "../common/GliderUtils";
import {REST_PILOT_URL} from "../common/constants";
import {completePilotName} from "../common/StringUtils";
import {sortPilots} from "../pilot/PilotUtils";

const LoggerType = {
  FLARM : 'FLARM',
  OGN : 'OGN',
};

const GLIDER_FORM_EMPTY_ENTITY = {
  name: "",
  registration: "",
  cn: "",
  twoSeat: false,
  foreignFlag: false,
  active: true,
  loggerAddress: "",
  loggerAddressType: "",
  description: "",
  ownerId: null
};

export const GliderForm = ({ entity = GLIDER_FORM_EMPTY_ENTITY, onSave = f => f }) => {

  const [name, setName] = useState(entity.name);
  const [registration, setRegistration] = useState(entity.registration);
  const [cn, setCn] = useState(entity.cn);
  const [description, setDescription] = useState(entity.description);
  const [foreign, setForeign] = useState(entity.foreignFlag);
  const [gliderActive, setGliderActive] = useState(entity.active !== false);
  const [ownerId, setOwnerId] = useState(entity.ownerId);
  const [twoSeat, setTwoSeat] = useState(entity.twoSeat);
  const [pilots, setPilots] = useState([]);
  const [loggerAddressType, setLoggerAddressType] = useState(entity.loggerAddressType);
  const [loggerAddress, setLoggerAddress] = useState(entity.loggerAddress);

  const submit = e => {
    e.preventDefault();
    const glider = {
      name: name,
      registration: registration,
      cn : cn,
      description : description,
      twoSeat : twoSeat,
      foreignFlag : foreign,
      active: gliderActive,
      loggerAddress: loggerAddress,
      loggerAddressType: loggerAddressType,
      ownerId: ownerId
    }
    onSave(glider);
  };

  const loadPilots = async () => {
      const resource = await loadResource(REST_PILOT_URL, null);
      if (resource) {
        let list = resource._embedded["pilot"];
        if (list) {
          list = list.sort(sortPilots);
        }
        setPilots(list);
      }
      return resource;
  }

  useEffect(() => {
    if (foreign && pilots.length === 0) {
      loadPilots();
    }
  }, [foreign, pilots.length]);

  useEffect(() => {
    setName(entity.name ?? "");
    setRegistration(entity.registration ?? "");
    setCn(entity.cn ?? "");
    setDescription(entity.description ?? "");
    setForeign(!!entity.foreignFlag);
    setGliderActive(entity.active !== false);
    setOwnerId(entity.ownerId ?? null);
    setTwoSeat(!!entity.twoSeat);
    setLoggerAddressType(entity.loggerAddressType ?? "");
    setLoggerAddress(entity.loggerAddress ?? "");
  }, [entity]);


  return (
      <form onSubmit={submit}>
        <IonList>
          <IonItem>
            <IonLabel position="stacked">Název kluzáku</IonLabel>
            <IonInput onIonChange={(e) => setName(e.detail.value)} value={name} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Imatrikulace</IonLabel>
            <IonInput onIonChange={(e) => setRegistration(e.detail.value)} value={registration} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Startovní znak</IonLabel>
            <IonInput onIonChange={(e) => setCn(e.detail.value)} value={cn} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Popis</IonLabel>
            <IonInput onIonChange={(e) => setDescription(e.detail.value)} value={description} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Dvousedadlový</IonLabel>
            <IonCheckbox onIonChange={(e) => setTwoSeat(e.detail.checked)} checked={twoSeat} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Cizí</IonLabel>
            <IonCheckbox onIonChange={(e) => setForeign(e.detail.checked)} checked={foreign} />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Aktivní (zobrazovat ve výběrech)</IonLabel>
            <IonCheckbox onIonChange={(e) => setGliderActive(e.detail.checked)} checked={gliderActive} />
          </IonItem>
          {foreign && <IonItem>
            <IonLabel>Vlastník</IonLabel>
            <IonSelect onIonChange={(e) => setOwnerId(e.target.value)} value={ownerId}>
              <IonSelectOption value="null">Žádný</IonSelectOption>
              { pilots.map((pilot, i) => {
                return (
                    <IonSelectOption key={pilot.id} value={pilot.id}>
                      {completePilotName(pilot)}
                    </IonSelectOption>
                );
              }) }
            </IonSelect>
          </IonItem>
          }
          <IonItem>
            <IonGrid fixed={true} className={'no-padding'}>
              <IonRow className={'no-padding'}>
                <IonCol size="6" sizeXs="6">
                  <IonLabel position="stacked">OGN/FLARM</IonLabel>
                  <IonSelect
                      value={loggerAddressType}
                      placeholder="Vyber typ"
                      onIonChange={(e) => setLoggerAddressType(e.detail.value)}
                  >
                    {Object.values(LoggerType).map((type) => (
                        <IonSelectOption key={type} value={type} selected={type === loggerAddressType}>
                          {type.toUpperCase()}
                        </IonSelectOption>
                    ))}
                  </IonSelect>

                </IonCol>
                <IonCol size="6" sizeXs="6">
                  <IonLabel position="stacked">adresa</IonLabel>
                  <IonInput
                      value={loggerAddress}
                      maxlength={6}
                      placeholder="Např. A1B2C3"
                      onIonInput={(e) => {
                        const input = e.detail.value || '';
                        //console.log('Input:', input);
                        const filtered = input.toUpperCase().replace(/[^0-9A-F]/g, '').slice(0, 6);
                        //console.log('Filtered:', filtered);
                        // Prevent the unfiltered value from being shown
                        e.target.value = filtered;
                        setLoggerAddress(filtered);
                      }}
                      />
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonItem>
        </IonList>
        <IonFooter>
          <IonButton expand={'full'} type="submit">Uložit</IonButton>
        </IonFooter>
      </form>
  )
};



class Glider extends Component {

  constructor(props) {
    super(props);
    this.state = {
      glider : props.entity,
      editModal: false
    };
    this.onUpdate = this.onUpdate.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    //console.log("nextProps: " + nextProps.toSource());
    if (nextProps.entity._links.self.href !== this.state.glider._links.self.href) {
      this.setState({glider :nextProps.entity});
    }
  }

  showModal() {
    this.setState({
      editModal: true
    })
  }

  closeModal() {
    this.setState({
      editModal: false
    })
  }

  async onUpdate(entity) {
    this.closeModal();
    const {glider} = this.state;
    const p = await updateResource(glider._links.self.href, entity);
    this.setState({glider: p});
  }

  isActive() {
    const {glider} = this.state;
    const {active} = this.props;
    return glider && active && (
        active.id === glider.id || (active._links && active._links.self &&
        active._links.self.href === glider._links.self.href)
    );
  }

  render() {
    const {glider, editModal } = this.state;
    const isActive = this.isActive();
    const setGlider = this.props.setGlider ? this.props.setGlider : f => f;
    return (
        <>
        { glider ?
              <IonItem color={isActive ? "secondary" : glider.active === false ? "medium" : ""}>
                <IonLabel onClick={() => setGlider(glider)}>
                  <h2>{glider.name}{glider.owner ? <span className={'small'}>{glider.owner}</span>:''}</h2>
                  <h3>{glider.registration}{glider.cn ? " ("+ glider.cn + ")": ""}</h3>
                </IonLabel>
                <IonButtons slot={'end'}>
                  {gliderInfo(glider)}
                  <IonButton size="small" onClick={() => this.props.deleteEntity(glider)}>
                    <IonIcon icon={trash}/>
                  </IonButton>
                  <IonButton size="small" onClick={() => this.showModal()}>
                    <IonIcon icon={create}/>
                  </IonButton>
                </IonButtons>

                <IonModal isOpen={editModal} backdropDismiss={false}>
                  <IonHeader translucent={true}>
                    <IonToolbar>
                      <IonTitle>Editace kluzáku</IonTitle>
                      <IonButtons slot="end">
                        <IonButton onClick={() => this.closeModal()}>Zavřít</IonButton>
                      </IonButtons>
                    </IonToolbar>
                  </IonHeader>
                  <IonContent>
                    <GliderForm entity={glider} onSave={this.onUpdate}/>
                  </IonContent>
                </IonModal>
              </IonItem>
              :
              <IonItem>
                Chyba
              </IonItem>
        }
        </>

    )
  }
}

export default Glider;